import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const AFHS_ClinicalSupervisionParaprofessionals = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='AFHS_ClinicalSupervisionParaprofessionals' className='file-pdf-document'>
            <div className='file-template'> 
            <p className='w-750'><h3>Verification of Clinical Supervision for Paraprofessionals</h3>
                </p>
                <p className='w-750'>To verify completion of supervised clinical experience, this form is to be completed by the supervisor and submitted with the application package.
                    All areas on the form must be completed.
                </p>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Name:</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date:</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Duration:</span></td>
                    </tr>

                    <tr>
                        <td className='w-450'>
                            <input type='text' id='txtName_1' name='txtName_1' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtDate_2' name='txtDate_2' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_3' name='txtDuration_3' className='add-only'/></td>
                    </tr>

                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Agency's Name:</span></td>
                        <td className='w-300'>
                            <span className='eleHeader'>Business Phone Number:</span></td>
                    </tr>

                    <tr>
                        <td className='w-450'>
                            <input type='text' id='txtAgencyName_4' name='txtAgencyName_4' placeholder='APEX Family Healthcare Services' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtBusinessPhoneNumber_5' name='txtBusinessPhoneNumber_5' placeholder='678-782-7272' className='add-only'/></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Agency's Mailing Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAgencyMailingAddress_6' name='txtAgencyMailingAddress_6' placeholder='301 Country Club Drive Stockbridge Georgia 30281' className='add-only'/></td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Supervision Type:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbSupervisionType_1' name='rbSupervisionType' className='add-only' value='Individual'/> Individual</td>
                        <td className='w-250'>
                            <input type='radio' id='rbSupervisionType_2' name='rbSupervisionType' className='add-only' value='Group'/> Group</td>
                        <td className='w-250'>
                            <input type='radio' id='rbSupervisionType_3' name='rbSupervisionType' className='add-only' value='Teleconference'/> Teleconference
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Supervisor's Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtSupervisorName_7' name='txtSupervisorName_7' className='add-only'/></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Type of License:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>License Number:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State of License:</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtTypeOfLicense_8' name='txtTypeOfLicense_8' placeholder='LPC' className='add-only'/></td>
                        <td className='w-250'>
                            <input type='text' id='txtLicenseNumber_9' name='txtLicenseNumber_9' className='add-only'/></td>
                        <td className='w-250'>
                            <input type='text' id='txtStateOfLicense_10' name='txtStateOfLicense_10' placeholder='GA' className='add-only'/></td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'>SERVICES RENDERED BY THE APPLICANT UNDER YOUR SUPERVISION:</span>
                    <span className='small'>Include population of clients, assessments used, and counseling techniques used.  For example: Skill building for individual, skill building for family.</span>
                    <textarea id='txtServicesRenderedByTheApplicant_1' name='txtServicesRenderedByTheApplicant_1' className='add-only'></textarea>

                </p>

                <p className='w-750'>
                    <span className='eleHeader'>SUPERVISION PROVIDED TO APPLICANT:</span>
                    <span className='small'>Provide detailed information.For example: assess counseling skills; review treatment plans; monitor assessments; case records; supervise family interventions and family groups; monitor discharge planning; crisis intervention and referrals; maintenance of case records; discuss ethical relationships with clients and ethical issues.
                        Checked in with supervisee (PP) about immediate concerns and clinical challenges.Reviewed policy/program updates with supervisee (PP). See Agenda
                    </span>
                    <textarea id='txtSupervisionProvidedToApplicant_2' name='txtSupervisionProvidedToApplicant_2' className='add-only'></textarea>

                </p>

                <p className='w-750'><h4>EVALUATION OF APPLICANT</h4>
                    <span>To complete the supervision requirements, applicants must demonstrate minimum competency in the areas listed below.  Please check your evaluation of the applicant in each area listed below.</span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>1.Application of an Identified Theory Base</span>
                            <span>Applicant was able to demonstrate skill in the application of an identified skill building,  and was able to comprehend the concepts of major feature of the approach.</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbApplicantWasAbleTo_Yes' name='rbApplicantWasAbleTo' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbApplicantWasAbleTo_No' name='rbApplicantWasAbleTo' className='add-only' value='No'/> No</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>2.Application of a Differential Diagnosis</span>
                            <span>Applicant was able to demonstrate skill in the application of a diagnosis
                                and was able to apply client symptoms and behaviors in appropriate skill building.</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbApplicationOfDifferentialDiagnosis_Yes' name='rbApplicationOfDifferentialDiagnosis' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbApplicationOfDifferentialDiagnosis_No' name='rbApplicationOfDifferentialDiagnosis' className='add-only' value='No'/> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>3.Establishing and Monitoring a Treatment Plan</span>
                            <span>Applicant was able to demonstrate skill in establishing and monitoring a treatment
                                plan, and to apply the components of the treatment plan to the diagnostic assessment.</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbEstablishingAndMonitoring_Yes' name='rbEstablishingAndMonitoring' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbEstablishingAndMonitoring_No' name='rbEstablishingAndMonitoring' className='add-only' value='No'/> No</td>


                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>4.Development and Appropriate Use of the Professional Relationship</span>
                            <span>Applicant was able to demonstrate skill in the development and appropriate use of the
                                professional relationship, and was able to apply the necessary skills to develop a
                                professional relationship in the phases of the treatment process.
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDevelopmentAndAppropriateUseOfThe_Yes' name='rbDevelopmentAndAppropriateUseOfThe' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbDevelopmentAndAppropriateUseOfThe_No' name='rbDevelopmentAndAppropriateUseOfThe' className='add-only' value='No'/> No</td>


                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>5.Assessing the Client for Risk of Imminent Danger and Taking Appropriate and Necessary Action to Protect the Safety of the Client, Others, the Public, and the Social Worker When Necessary</span>
                            <span>Applicant was able to demonstrate skill in assessing the client for risk of imminent danger  and taking appropriate and necessary action to protect the safety of the client, others, the public, and the social worker when necessary.  Applicant was able to apply the criteria for actual or potential risk of a client or professional practice situation and provide the appropriate steps to be taken.
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAssessingTheClientForRisk_Yes' name='rbAssessingTheClientForRisk' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbAssessingTheClientForRisk_No' name='rbAssessingTheClientForRisk' className='add-only' value='No'/> No</td>


                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>6.Implementing a Professional and Ethical Relationship with Clients</span>
                            <span>Applicant was able to demonstrate skill in implementing a professional and ethical
                                relationship with clients, and was able to apply the appropriate professional and
                                ethical responsibilities in relation to a client situation.

                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbImplementingProfessionalAndEthical_Yes' name='rbImplementingProfessionalAndEthical' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbImplementingProfessionalAndEthical_No' name='rbImplementingProfessionalAndEthical' className='add-only' value='No'/> No</td>


                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>7.Case Management and Record Keeping</span>
                            <span>Applicant maintains appropriate clinical records and client data, and understands the circumstances under which various records can be released.

                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbCaseManagementAndRecordKeeping_Yes' name='rbCaseManagementAndRecordKeeping' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbCaseManagementAndRecordKeeping_No' name='rbCaseManagementAndRecordKeeping' className='add-only' value='No'/> No</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>8.Professional Identity and Ethics</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>8.1  Applicant uses supervision and shows continuing development of clinical skills</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbProfessionalIdentityAnd_1_Yes' name='rbProfessionalIdentityAnd_1' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbProfessionalIdentityAnd_1_No' name='rbProfessionalIdentityAnd_1' className='add-only' value='No'/> No </td>

                    </tr>

                    <tr>
                        <td className='w-750'>8.2  Applicant demonstrates knowledge of strengths and limitations of a clinical social
                            worker and the distinctive contributions of other mental health and health professionals.
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbProfessionalIdentityAnd_2_Yes' name='rbProfessionalIdentityAnd_2' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbProfessionalIdentityAnd_2_No' name='rbProfessionalIdentityAnd_2' className='add-only' value='No'/> No </td>
                    </tr>
                    <tr>

                        <td className='w-750'>8.3  Applicant makes appropriate referrals to other health providers and resources in the
                            community.</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbProfessionalIdentityAnd_3_Yes' name='rbProfessionalIdentityAnd_3' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbProfessionalIdentityAnd_3_No' name='rbProfessionalIdentityAnd_3' className='add-only' value='No'/> No </td>

                    </tr>

                    <tr>
                        <td className='w-750'>8.4  Applicant knows and understands the laws related to life-threatening situations, child  abuse, elder abuse, physical abuse, etc.</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbProfessionalIdentityAnd_4_Yes' name='rbProfessionalIdentityAnd_4' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbProfessionalIdentityAnd_4_No' name='rbProfessionalIdentityAnd_4' className='add-only' value='No'/> No </td>

                    </tr>

                    <tr>

                        <td className='w-750'>8.5  Applicant understands and has discussed the ethics of confidentiality and other legal and ethical issues.</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbProfessionalIdentityAnd_5_Yes' name='rbProfessionalIdentityAnd_5' className='add-only' value='Yes'/> Yes &nbsp;
                            <input type='radio' id='rbProfessionalIdentityAnd_5_No' name='rbProfessionalIdentityAnd_5' className='add-only' value='No'/> No </td>

                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txtAdditionalComments_3' name='txtAdditionalComments_3' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>DECLARATION OF SUPERVISOR:</h4>
                    <span>I declare that, to the best of my knowledge, the foregoing is true and correct.</span></p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Supervisee Signature</td>
                        <td className='small w-375'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Supervisor's Signature</td>
                        <td className='small w-375'>Date</td>
                    </tr>


                </table>

            

 



            </div>
        </form>

    )
}   